import { inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarRef,
  TextOnlySnackBar,
} from '@angular/material/snack-bar';
import { DrawerService } from '../components/right-drawer/drawer.service';
import { combineLatest, map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private drawerService = inject(DrawerService);
  private snackBar = inject(MatSnackBar);

  openSnackBar(
    text: string,
    actionText = '',
    duration = 4000,
  ): Observable<MatSnackBarRef<TextOnlySnackBar>> {
    return this.openSnackBarWithConfig(text, actionText, duration);
  }

  openWarningSnackBar(
    text: string,
    actionText = '',
    duration = 4000,
  ): Observable<MatSnackBarRef<TextOnlySnackBar>> {
    return this.openSnackBarWithConfig(text, actionText, duration, ['warning-panel-snackbar']);
  }

  private openSnackBarWithConfig(
    text: string,
    actionText: string,
    duration: number | undefined,
    panelClass: string[] = [],
  ) {
    const snackBarRef$: Observable<MatSnackBarRef<TextOnlySnackBar>> = combineLatest([
      this.drawerService.drawerState$,
    ]).pipe(
      take(1),
      map(([{ data }]) => {
        const config: MatSnackBarConfig = data
          ? {
              panelClass: [...panelClass, 'snackbar-candidate-details-drawer'],
              horizontalPosition: 'center',
              duration,
            }
          : { panelClass, duration };

        return this.snackBar.open(text, actionText, config);
      }),
    );
    snackBarRef$.subscribe();
    return snackBarRef$;
  }
}
